import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const searchIcon = require("./../assets/img/search-icon.svg").default;
const removeIcon = require("./../assets/img/remove-icon.svg").default;
const downloadIcon = require("./../assets/img/download-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const CrossBtn = require("./../assets/img/cross-icon.svg").default;
const logo = require("./../assets/img/logo.svg").default;
const companyLogo = require("./../assets/img/company-logo.svg").default;
const signature = require("./../assets/img/signature.png");

const ViewFiles = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [pageNumber, setPageNumber] = useState("1");
  const [pageLimit, setPageLimit] = useState("5");
  const [totalRecord, setTotalRecord] = useState(0);
  const [timer, setTimer] = useState(null);
  const filesPerPage = 5; // Number of files to display per page
  const [userData, setUserData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [jobNumber, setJobNumber] = useState();
  const [storeName, setStoreName] = useState();
  const [fileData, setFileData] = useState([]);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleCheckboxChange = (event, fileName) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };

  const delayExecution = (callback, ms) => {
    clearTimeout(timer);
    const newTimer = setTimeout(callback, ms);
    setTimer(newTimer);
  };

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);

    delayExecution(() => {
      formDataSubmit(pageNumber, event.target.value);
    }, 500);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPageNumber(pageNumber);
    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    // Perform search action using the searchQuery value
    console.log("Search Query:", searchQuery);
  };

  const handlePreviewBtnClick = (formKey) => {
    navigate(`/form-preview/${formKey}`);
    setShowPreviewPopup(true);
  };

  const popupBtnClick = () => {
    setShowPreviewPopup(false);
  };

  const showPagination = Math.ceil(totalRecord / filesPerPage);

  const totalPages = Math.ceil(totalRecord / filesPerPage); // Calculate total pages

  const fetchAllFiles = (storedUserData) => {
    formDataSubmit(pageNumber, searchKey);
  };

  const formDataSubmit = (pageNumber, searchKey) => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters
    const form = new FormData();
    form.append("from_date", fromDate);
    form.append("to_date", toDate);
    form.append("search_key", searchKey);
    form.append("page_no", pageNumber);
    form.append("limit", pageLimit);
    form.append("job_code", jobNumber ? jobNumber : "");
    form.append("store_name", storeName ? storeName : "");
    form.append("status", 1);

    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/all/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "POST",
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setFileData(data.data);

          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setFileData([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  const handleRemoveClick = (index, fileId) => {
    setFileToRemove({ index, fileId });
    setShowConfirmationModal(true);
  };

  const deleteFile = () => {
    if (fileToRemove) {
      const { index, fileId } = fileToRemove;
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      fetch(
        `https://cliqestimatebuilder.com/waiver_admin/forms/trash/${fileId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${storedUserData.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.res == 1) {
            // Update the file list by removing the file at the specified index
            fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch((error) =>
          console.error("Error changing delete status:", error)
        );

      setShowConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
    fetchAllFiles(storedUserData);
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox">
            <div className="topSearch">
              <div className="searchSec">
                <h2>All Signed Forms</h2>

                <div className="rgtSearch">
                  <form onSubmit={handleSearchSubmit}>
                    <input
                      type="search"
                      placeholder="Search here"
                      value={searchKey}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button type="submit">
                      <img src={searchIcon} alt="" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="viewFileList">
              <h3>Total {totalRecord} signed forms</h3>
              <div className="listing signedFrm">
                <table>
                  <thead>
                    <tr>
                      {/* <th></th> */}
                      <th>Name</th>
                      <th>Create On</th>
                      <th>Recipient email id</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {fileData?.length > 0 ? (
                    <tbody>
                      {fileData.map((file, index) => (
                        <tr
                          key={index}
                          className={
                            selectedFiles.includes(file.id) ? "active" : ""
                          }
                        >
                          {/* <td className="checkWidth">
                            <input
                              type="checkbox"
                              checked={selectedFiles.includes(file.id)}
                              onChange={(event) =>
                                handleCheckboxChange(event, file.id)
                              }
                            />
                          </td> */}
                          {/* <td className="countWidth">{index + 1}</td> */}
                          <td className="formName">{file.form_name}</td>
                          <td>{file.created_at}</td>
                          <td>{file.email}</td>
                          <td className={"signedBtn"}> Signed</td>

                          <td className="btnsWidth">
                            <button>
                              <Link
                                to={
                                  "https://cliqestimatebuilder.com/waiver_admin/" +
                                  file?.pdf
                                }
                                target="_blank"
                              >
                                <img src={downloadIcon} alt="View" />
                              </Link>
                            </button>
                            <button>
                              <Link
                                to={`/form-preview/${file?.form_key}`}
                                target={"_blank"}
                              >
                                <img src={viewIcon} alt="View" />
                              </Link>
                            </button>
                            <button>
                              <Link
                                to=""
                                onClick={() =>
                                  handleRemoveClick(index, file.id)
                                }
                              >
                                <img src={removeIcon} alt="View" />
                              </Link>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {/* <tr>
                        <td className="checkWidth">
                          <input type="checkbox" />
                        </td>
                        <td className="viewFormName">Form-1</td>
                        <td>05 July, 2023</td>
                        <td>james.123@smaple.com</td>
                        <td className="signedBtn">Signed</td>
                        <td className="btnsWidth">
                          <button>
                            <Link to="">
                              <img src={downloadIcon} alt="View" />
                            </Link>
                          </button>
                          <button onClick={handlePreviewBtnClick}>
                            <img src={viewIcon} alt="View" />
                          </button>
                          <button>
                            <Link to="">
                              <img src={removeIcon} alt="View" />
                            </Link>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="checkWidth">
                          <input type="checkbox" />
                        </td>
                        <td className="viewFormName">Form-1</td>
                        <td>05 July, 2023</td>
                        <td>james.123@smaple.com</td>
                        <td className="signedBtn">Signed</td>
                        <td className="btnsWidth">
                          <button>
                            <Link to="">
                              <img src={downloadIcon} alt="View" />
                            </Link>
                          </button>
                          <button onClick={handlePreviewBtnClick}>
                            <img src={viewIcon} alt="View" />
                          </button>
                          <button>
                            <Link to="">
                              <img src={removeIcon} alt="View" />
                            </Link>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="checkWidth">
                          <input type="checkbox" />
                        </td>
                        <td className="viewFormName">Form-1</td>
                        <td>05 July, 2023</td>
                        <td>james.123@smaple.com</td>
                        <td className="signedBtn">Signed</td>
                        <td className="btnsWidth">
                          <button>
                            <Link to="">
                              <img src={downloadIcon} alt="View" />
                            </Link>
                          </button>
                          <button onClick={handlePreviewBtnClick}>
                            <img src={viewIcon} alt="View" />
                          </button>
                          <button>
                            <Link to="">
                              <img src={removeIcon} alt="View" />
                            </Link>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="checkWidth">
                          <input type="checkbox" />
                        </td>
                        <td className="viewFormName">Form-1</td>
                        <td>05 July, 2023</td>
                        <td>james.123@smaple.com</td>
                        <td className="signedBtn">Signed</td>
                        <td className="btnsWidth">
                          <button>
                            <Link to="">
                              <img src={downloadIcon} alt="View" />
                            </Link>
                          </button>
                          <button onClick={handlePreviewBtnClick}>
                            <img src={viewIcon} alt="View" />
                          </button>
                          <button>
                            <Link to="">
                              <img src={removeIcon} alt="View" />
                            </Link>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="checkWidth">
                          <input type="checkbox" />
                        </td>
                        <td className="viewFormName">Form-1</td>
                        <td>05 July, 2023</td>
                        <td>james.123@smaple.com</td>
                        <td className="signedBtn">Signed</td>
                        <td className="btnsWidth">
                          <button>
                            <Link to="">
                              <img src={downloadIcon} alt="View" />
                            </Link>
                          </button>
                          <button onClick={handlePreviewBtnClick}>
                            <img src={viewIcon} alt="View" />
                          </button>
                          <button>
                            <Link to="">
                              <img src={removeIcon} alt="View" />
                            </Link>
                          </button>
                        </td>
                      </tr> */}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan={6} className="clsPan">
                        <span class="lgnStatus">Files Not Found</span>
                      </td>
                    </tr>
                  )}
                  {showConfirmationModal ? (
                    <div className="confirmation-modal">
                      <div className="modal-content">
                        <p>Are you sure you want to remove this file?</p>
                        <div className="modal-buttons">
                          <button onClick={() => deleteFile()}>Yes</button>
                          <button
                            onClick={() => setShowConfirmationModal(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </table>
              </div>
            </div>

            {showPagination ? (
              <div className="paginationDiv">
                <ul>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index}>
                      <Link
                        to="#"
                        className={currentPage === index + 1 ? "active" : ""}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFiles;
